import { useQuery } from "@tanstack/react-query";
import type { SellerOrderPaymentResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseOrderPaymentTransactionQueryParams = {
  storeSlug: string;
  orderId: string;
};

// The latest online-payment transaction for an order (null for COD/manual).
export function useOrderPaymentTransactionQuery({
  storeSlug,
  orderId,
}: UseOrderPaymentTransactionQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.orderPaymentTransaction(storeSlug, orderId),
    queryFn: () =>
      apiJsonClient<SellerOrderPaymentResponse>(
        endpoints.seller.orderPaymentTransaction(orderId),
      ),
    enabled: storeSlug.length > 0 && orderId.length > 0,
  });

  return {
    transaction: query.data?.transaction ?? null,
    isLoading: query.isLoading,
    error: query.error,
  };
}
